import { createFileRoute } from '@tanstack/react-router';

import { ProviderOpeningsPage } from '@/features/services/provider/openings-page';

export const Route = createFileRoute('/_app/me/services/openings')({
  component: ProviderOpeningsPage,
});
